import { types as numberTypes } from "./number.actions";
import { types as formTypes } from "./../form.actions";
import { validate, mapForDisplay } from "./number.domain";

export const defaultState = {
  value: null,
  valid: false,
  pristine: true,
};

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case numberTypes.INPUT:
      return {
        value: action.value,
        valid: validate(action.value),
        pristine: false,
      };
    case numberTypes.BLUR:
      return {
        ...state,
        value: mapForDisplay(state.value),
      };
    case formTypes.CLEAR:
      return {
        value: action.card ? action.card.number : defaultState.value,
        valid: !!action.card,
        pristine: true,
      };
    default:
      return state;
  }
};
